import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from '../subscription.model';
import { AutorunComponent } from '@myshared/autorun.component';
import { Model } from '../../app.model';
import { ActivatedRoute, Router } from '@angular/router';
import { slaProductNames } from 'src/app/buy/select-product/product.model';
import { DeviceService } from 'src/app/device.service';
import { IntegrationAppsService } from 'src/app/integration-apps/integration-apps.service';
import { IntegrationAppInstallation_State } from '@proto/odoo/integrations';

@Component({
    selector: 'app-subscription-card',
    templateUrl: './subscription-card.component.html',
    styleUrls: [],
    standalone: false
})
export class SubscriptionCardComponent extends AutorunComponent implements OnInit {

  private _subscription: Subscription;
  @Input()
  public set subscription(s: Subscription) {
    this._subscription = s;
  }
  public get subscription(): Subscription {
    return this._subscription;
  }

  @Input()
  showSubscriptionDetailLink = false;
  @Input()
  detaillist = false;
  @Input()
  withBorder = false;
  @Input()
  public installationState?: IntegrationAppInstallation_State;
  @Input()
  public installedVersion: number = 0;
  @Input()
  public currentAppVersion: number = 0;

  @Output() 
  public upgradeAppInstallation = new EventEmitter<UpgradeAppInstallationEvent>();
  @Output()
  public retryInstallOrUpgradeRequest = new EventEmitter<number>();

  public isAdmin = false;
  public isPartner: boolean;

  constructor(
    private m: Model,
    private route: ActivatedRoute,
    private router: Router,
    private deviceService: DeviceService,
    public integrationService: IntegrationAppsService) { super(); }

  ngOnInit() {
    this.autorun(() => {
      this.isAdmin = this.m.account.isMypascomAdmin;
      this.isPartner = this.m.account.currentUser.companyIsPartner;
    });
  }

  public get isOneAndCancelled() {
    return this.subscription.isOne && this.subscription.cancelled;
  }

  public get status(): { status: string; color: any } {
    return this.subscription.pbxStatus;
  }

  public showDetails() {
    if (this.canShowDetails) {
      this.router.navigate(['/subscriptions', this._subscription.appliance_id])
    }
  }

  public get canShowDetails() {
    return this.detaillist && this.subscription.isValid;
  }

  private get isUpgradeAvailable(): boolean {
    const maxSlaOption = slaProductNames[slaProductNames.length - 1];
    return this.isAdmin && !this.subscription.isCancelled
  }

  public get canUpgradeAfterExpired() {
    return this.subscription.isOneTrial || this.isUpgradeAvailable;
  }

  public get licTypeName() {
    return this.subscription.license_type === "one" ? "pascom One" : "pascom Trial";
  }

  public get showUpgradeBtn() {
    return (this.installedVersion < this.currentAppVersion) && 
      (this.installationState === IntegrationAppInstallation_State.STATE_INSTALLED ||
        this.installationState === IntegrationAppInstallation_State.STATE_INSTALL_FAILED);
  }

  // only allow an uninstall when the app is correctly installed
  public get showMenu() {
    return this.installationState === IntegrationAppInstallation_State.STATE_INSTALLED;
  }

  public get showRetryBtn() {
    return (this.installedVersion === this.currentAppVersion) &&
      this.installationState === IntegrationAppInstallation_State.STATE_INSTALL_FAILED;
  }

  retryAction(applianceId: string) {
    this.retryInstallOrUpgradeRequest.emit(Number(applianceId));
  }

  upgradeIntegrationAppInstallation(applianceId: string, installedVersion: number) {
    this.upgradeAppInstallation.emit({applianceId, installedVersion});
  }

}

export interface UpgradeAppInstallationEvent {
  applianceId: string;
  installedVersion: number;
}
